module.exports = __webpack_public_path__ + "8e2078a09e44099c2b4f7d160b25763d.svg";